<template>
  <div>
    <section class="home-sec-1">
      <template v-if="isMobile">
        <ul class="slider-mb">      
          <carousel
            :perPage="1"
            :mouse-drag="false"
            :navigationEnabled="false"
            :paginationEnabled="true"
            :loop="true"
            :autoplay="true"
            :speed="1000"
            :autoplayTimeout="3000">
            <slide v-for="(banner,index) in idxBanners" :key="index">
              <template v-if="checkBannerType(banner.href)">
                <a :href="banner.href" target="_blank">
                  <img :src='fileUrl(`${banner.pcimg}`)'>
                </a>
              </template>
              <template v-else>
                <li>
                  <router-link :to="`/${banner.href}`" :target="banner.target">
                    <img :src='fileUrl(`${banner.pcimg}`)'>
                  </router-link>
                </li>
              </template>
            </slide>
          </carousel>      
        </ul>
      </template>
      <template v-else>
        <ul class="slider-pc">      
          <carousel
            :perPage="1"
            :mouse-drag="false"
            :navigationEnabled="true"
            :navigationNextLabel="`<span class='icon-32'></span>`"
            :navigationPrevLabel="`<span class='icon-32'></span>`"
            :paginationEnabled="false"
            :loop="true"
            :autoplay="true"
            :speed="1000"
            :autoplayTimeout="3000">
            <slide v-for="(banner,index) in idxBanners" :key="index">
              <template v-if="checkBannerType(banner.href)">
                <a :href="banner.href" target="_blank">
                  <img :src='fileUrl(`${banner.pcimg}`)'>
                </a>
              </template>
              <template v-else>
                <li>
                  <router-link :to="`/${banner.href}`" :target="banner.target">
                    <img :src='fileUrl(`${banner.pcimg}`)'>
                  </router-link>
                </li>
              </template>
            </slide>
          </carousel>      
        </ul>
      </template>
      <ul class="home-point">
        <u-animate-container>
          <u-animate v-for="(list,index) in idxPoints" 
            name="fadeInUp"
            :delay="delaySec[index]"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
            :key="index"
          >
            <li :key="index">
              <router-link :to="list.link">
                <div class="point-img">
                  <img :src='require(`@img/${list.img}`)'>
                  <span>{{$t(`${list.title}`)}}</span>
                </div>
                <div class="point-content" v-html=$t(list.narrs)></div>
              </router-link>
            </li>
          </u-animate>
        </u-animate-container>
      </ul>
    </section>
    <section class="home-sec-2" v-if="false">
      <div class="underLineHeading">
        <span>{{$t("lang_home_about_title")}}</span>
      </div>
      <div class="home-about-content">
        <span v-html="$t('lang_home_about_content_pc')"></span>
        <span v-html="$t('lang_home_about_content_mb')"></span>
      </div>
      <div class="home-video">
        <iframe style="width:100%;height:100%;" src="https://www.youtube.com/embed/dUqA1A5iwcI" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen v-if="isYoutube"></iframe>
        <div id="youkuplayer" style="width:100%;height:100%;" v-else></div>
      </div>
    </section>
    <section class="home-sec-3">
      <div class="home-dynamic" :style="{zIndex: zindex}">
        <video controls id="myVideo" @ended="videoEnded" @play="videoPlay" :style="{zIndex: zindex}">
          <source src="https://mov.rollingbet.com/index.b913b456.mp4" type="video/mp4">
          Your browser does not support HTML5 video.
        </video>
      </div>
      <div class="cover" @mousemove="decMoving">
        <div class="title-block">
          <h1 v-if="!zindex">2019  ROLLING  BET</h1>
          <h1 v-if="!zindex" v-html="$t('lang_themeHeading_indexVideoTitle')">
          </h1>
          <div class="dec-block left">
            <img :src="require('@img/cover/cover-dec-techline-left.png')"
              :style="{right: decPosition.right + 'px',bottom: decPosition.bottom + 'px'}"
            >
          </div>
          <div class="dec-block right">
            <img :src="require('@img/cover/cover-dec-techline-right.png')"
              :style="{right: decPosition.right + 'px',bottom: decPosition.bottom + 'px'}"
            >
          </div>
          <div class="dec-block-mb left">
            <img :src="require('@img/cover/cover-dec-techline-left.png')">
          </div>
          <div class="dec-block-mb right">
            <img :src="require('@img/cover/cover-dec-techline-right.png')">
          </div>
        </div>
        <button class="play-btn" @click="videoPlay" v-if="!zindex">
          <span class="line"></span>
        </button>
      </div>
    </section>
    <section class="home-sec-4">
      <div class="underLineHeading">
        <span>{{$t('lang_men_serviceAdvantage')}}</span>
      </div>
      <ul class="home-superiority clearfix">
        <li v-for="(list,index) in advantage" :key="index">
          <div class="home-superiority-number">
            <div class="iCountUp">
              <ICountUp
                :startVal="startVal"
                :endVal="endVal[index]"
                :decimals="decimals"
                :duration="duration"
                :options="options"
                @ready="onReady"
              />
            </div>
          </div>
          <div class="home-superiority-title">{{list.title}}</div>
          <div class="home-superiority-content" v-html=(list.narrs)></div>
        </li>
      </ul>
      <router-link to="/support/prot" class="home-superiority-more"><span>{{$t('lang_men_more')}}</span><i>▲</i></router-link>
    </section>
    <section class="home-sec-5">
      <div class="platform_display-inner" @mouseenter="stop" @mouseleave="run">
        <ul>
          <marquee-text
            :paused="isMarquee"
            :duration="30">            
            <li v-for="(logo,index) in footerLogo" :key="index">
              <img :src='require(`@img/${logo.img}`)'>
            </li>
          </marquee-text>
        </ul>
      </div>
    </section>
  </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import {mapGetters} from 'vuex'
import {BACKEND_LOCATION} from '@api/Endpoints'
import {UAnimateContainer, UAnimate} from 'vue-wow'
import moment from 'moment'
import $ from 'jquery'
import ICountUp from 'vue-countup-v2'
import MarqueeText from 'vue-marquee-text-component'
import axios from 'axios'
import idxPoint from '@data/idxPoint.json'

export default {
  name: 'Home',
  components: {
    Carousel,
    Slide,
    MarqueeText,
    ICountUp,
    UAnimateContainer,
    UAnimate,
  },
  data(){
    return{
      idxBanners: [],
      idxPoints: [],
      sliderNews: [],
      listNews: [],
      isMobile: false,
      deviceModel: 'pc',
      isMarquee: false,
      isCount: 0,
      startVal: 0,
      endVal:[0,0,0],
      decimals: 0,
      duration: 2.5,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: '.',
        prefix: '',
        suffix: ''
      },
      delaySec:['0s','.1s','.2s','.3s'],
      countObj:[],
      countDone: false,
      isYoutube: false,
      video: null,
      zindex: 0,
      decPosition: {
        right: 0,
        botoom: 0
      }
    }
  },
  computed: {
    advantage(){
      return[
        {
          sum: 10,
          title: this.$t('lang_home_advantageList1_title'),
          narrs: this.$t('lang_home_advantageList1_subtitle')
        },{
          sum: 100,
          title: this.$t('lang_men_partner'),
          narrs: this.$t('lang_home_advantageList2_subtitle')
        },{
          sum: 24,
          title: this.$t('lang_men_hour'),
          narrs: this.$t('lang_home_advantageList3_subtitle')
        }
      ]
    },
    footerLogo(){
      return[
        {
          img: 'footer_bb.png'
        },{
          img: 'footer_pt.png'
        },{
          img: 'footer_ab.png'
        },{
          img: 'footer_188.png'
        },{
          img: 'footer_ag.png'
        },{
          img: 'footer_cmd.png'
        },{
          img: 'footer_ea.png'
        },{
          img: 'footer_gd.png'
        },{
          img: 'footer_gg.png'
        },{
          img: 'footer_jdb.png'
        },{
          img: 'footer_mg.png'
        },{
          img: 'footer_ow.png'
        },{
          img: 'footer_sg.png'
        },{
          img: 'footer_sunbet.png'
        },{
          img: 'footer_tgp.png'
        },{
          img: 'footer_n2.png'
        },{
          img: 'footer_cq9.png'
        },{
          img: 'footer_bg.png'
        }
      ]
    },
    ...mapGetters({
      defLangx: 'defLangx',
      nowLangx: 'nowLangx',
    }),
  },
  methods: {
    checkBannerType(content) {
      const handleContent = [...content].slice(0, 4).join("") === 'http'

      return handleContent
    },
    idxBannerInfo(info){
      this.idxBanners=info
    },
    idxPointInfo(info){
      this.idxPoints=info
    },
    getWinSize(){
      const $this = this;
      $(window).resize(function(){
        if($this.deviceModel === 'mb' && $(window).width() > 996) {
          $this.isMobile = false
          $this.deviceModel = 'pc'
        }else if ($this.deviceModel === 'pc' && $(window).width() <= 996){
          $this.isMobile = true
          $this.deviceModel = 'mb'
        }
      })
      if($this.deviceModel === 'mb' && $(window).width() > 996) {
        $this.isMobile = false
        $this.deviceModel = 'pc'
      }else if ($this.deviceModel === 'pc' && $(window).width() <= 996){
        $this.isMobile = true
        $this.deviceModel = 'mb'
      }        
    },
    newsSlider(data){
      const $this = this
      // const sortData = data.sort(function (a, b) {
      //   return a.id - b.id
      // });
      const sortData = data
      sortData.forEach(function(item,index){
        if(index>5){
          return
        }
        $this.$set($this.sliderNews, index, item)
      })
    },
    newsList(data){
      const $this = this
      // const sortData = data.sort(function (a, b) {
      //   return a.id - b.id
      // });
      const sortData = data
      sortData.forEach(function(item,index){
        if(index>2){
          return
        }
        $this.$set($this.listNews, index, item)
      })     
    },
    stop(){
      this.isMarquee = true
    },
    run(){
      this.isMarquee = false
    },
    runCount(){
      const $this = this
      if(
        $(window).scrollTop()+$(window).height()>=$('.home-sec-3').offset().top+($('.home-sec-4').outerHeight()/2)
        && this.isCount < 3
      ){
        $this.countObj.forEach(function(item,index){
          item.update($this.endVal[index] = $this.advantage[index].sum)
          $this.isCount = $this.isCount +=1;
          window.removeEventListener('scroll',$this.runCount)
        })
      }
    },
    onReady(instance){
      const $this = this;
      if($this.countObj.length < 3){
        $this.countObj.push(instance)
      }
      if($this.countObj.length === 3 && !$this.countDone){
        $this.countDone = true;
        window.addEventListener('scroll',this.runCount)
        $this.runCount()
      }
      
    },
    fileUrl(url){
      const img = url !=='undefined' && url!=='' ? BACKEND_LOCATION.file+url :false
      return img
    },
    getBannerData(){
      const $this = this
      const api = BACKEND_LOCATION.api + 'getdata/banner/'+this.nowLangx
      axios.post(api)
      .then(function (response) {
        const res = response.data
        switch(res.code){
          case "100":
            $this.idxBannerInfo(res.info)
            break
          default:
            console.log(error);
            break
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    getNewData(){
      const $this = this
      const api = BACKEND_LOCATION.api + 'getdata/news/'+this.nowLangx
      axios.post(api)
      .then(function (response) {
        const res = response.data
        switch(res.code){
          case "100":
            $this.newsSlider(res.info)
            $this.newsList(res.info)
            break
          default:
            console.log(error);
            break
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    getDateForm(date, form) {
      let nextDate = moment()
      switch(form){
        case 'Y':
          nextDate = moment(date).format('YYYY')
          break
        case 'M':
          nextDate = moment(date).format('MMM')
          break
        case 'D':
          nextDate = moment(date).format('DD')
          break
      }
      return nextDate
    },
    videoEnded() {
      this.zindex = 0
    },
    videoPlay() {
      this.video.play()
      this.zindex = 1
    },
    decMoving(e) {
      const view=e.view
      const { screenX: x, screenY: y } = e
      const {innerWidth:w,innerHeight:h}=view
      const xRate=x/w
      const yRate=y/h
      this.decPosition.right = -100 * xRate
      this.decPosition.bottom = -100 * yRate
    }
  },
  created() {
    this.getBannerData()
    this.getNewData()
  },
  mounted() {
    this.video = document.getElementById('myVideo')
    this.idxPointInfo(idxPoint)
    this.getWinSize()
    this.$store.dispatch('setLoadshow',false)
    this.isYoutube = this.defLangx === 'cn' ? false : true
    if(!this.isYoutube){
      $.getScript("//player.youku.com/jsapi", function() {
				var player = new YKU.Player('youkuplayer',{
					styleid: '0',
          client_id: 'a2hzp.8253869.0.0',
          vid: 'XMzY3MzY5Mjg3Mg',
          newPlayer: true
				});
			});
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll',this.runCount)
    this.$store.dispatch('setLoadshow',true)
  }
}
</script>

<style lang="sass">
  @import '@css/index.sass'
</style>

